/* NOTICE — Stack 4 pull (sections/notice-stack4-pull.liquid).
   The lamp's own mechanism: pull the NOTICE tab, the plate slides out, the stack drops out, and seven slabs fall
   back in from the top in one of 35 equally likely orders. As a demo, four yellows together win and nothing is
   awarded. With gifts switched on (section setting, data-prizes="on"), the first pull on a phone number is drawn by
   the leads worker, saved to that number and played back here; later pulls are for fun. */
(() => {
  "use strict";
  const NS = "http://www.w3.org/2000/svg";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const wide = window.matchMedia("(min-width: 1024px)");

  /* ---------- the game ---------- */
  /* Every possible order, top slab first. Listing yellow first fixes the order numbers 1 to 35. */
  const ORDERS = [];
  (function list(prefix, y, r) {
    if (prefix.length === 7) { ORDERS.push(prefix); return; }
    if (y > 0) list(prefix + "Y", y - 1, r);
    if (r > 0) list(prefix + "R", y, r - 1);
  })("", 4, 3);
  const TOP = "YYYYRRR";
  const START = "YRYRYRY";
  const kind = (s) => (s === TOP ? "top" : s.indexOf("YYYY") >= 0 ? "down" : "none");
  const orderNo = (s) => ORDERS.indexOf(s) + 1;
  const pad = (n) => String(n).padStart(2, "0");
  const words = (s) => Array.from(s, (c) => (c === "Y" ? "yellow" : "red")).join(", ");

  /* Gifts: what each order carries (the leads worker uses the same rule for the pull that counts). */
  const ALT = "YRYRYRY";
  const giftOf = (s) => (s === TOP ? "spring-stand" : s.includes("YYYY") ? "tetrapod" : s.includes("YYY") ? "sutli" : s === ALT ? "rs444" : "none");
  /* The rows a result points at, top slab = row 0: the run of yellows, or every yellow when they alternate. */
  function runOf(s) {
    const g = giftOf(s);
    if (g === "spring-stand" || g === "tetrapod") { const k = s.indexOf("YYYY"); return [k, k + 1, k + 2, k + 3]; }
    if (g === "sutli") { const k = s.indexOf("YYY"); return [k, k + 1, k + 2]; }
    if (g === "rs444") return [0, 2, 4, 6];
    return [];
  }
  const fourRun = (s) => { const k = s.indexOf("YYYY"); return k < 0 ? [] : [k, k + 1, k + 2, k + 3]; };
  const GIFT = {
    "spring-stand": { head: "Four on top.", name: "a Spring Stand", label: "Spring Stand", ships: "You pulled a Spring Stand. It ships free with your lamp." },
    tetrapod: { head: "Four in a row.", name: "a Tetrapod", label: "Tetrapod", ships: "You pulled a Tetrapod. It ships free with your lamp." },
    sutli: { head: "Three together.", name: "a Sutli candle holder", label: "Sutli candle holder", ships: "You pulled a Sutli candle holder. It ships free with your lamp." },
    rs444: { head: "Alternating.", name: "Rs. 444 off the lamp", label: "Rs. 444 off the lamp", ships: "You pulled Rs. 444 off your lamp." },
    none: { head: "Not this round.", name: "", label: "No gift", ships: "No gift on this number. The lamp still plays every night." },
  };
  /* What a pull for fun landed, said plainly under its "For fun." headline. */
  const SHAPE = { "spring-stand": "four on top", tetrapod: "four in a row", sutli: "three together", rs444: "alternating", none: "nothing lined up" };

  /* Unbiased draw from crypto randomness. A real launch pull is drawn on a server, never here. */
  function randIndex(n) {
    const buf = new Uint32Array(1);
    const limit = Math.floor(4294967296 / n) * n;
    let x;
    do { crypto.getRandomValues(buf); x = buf[0]; } while (x >= limit);
    return x % n;
  }

  /* ---------- sound: a ratchet as the plate comes out, a clatter as the stack falls, then the slabs play the order.
     Each slab lands on a note: the stack climbs a pentatonic scale as it fills, yellow rings bright, red sits an
     octave down, so every one of the 35 orders has its own seven-note tune. ---------- */
  const sound = { on: true, ctx: null, bus: null };
  try { sound.on = localStorage.getItem("s4pull-sound") !== "off"; } catch (e) {}
  function audio() {
    if (!sound.on) return null;
    if (!sound.ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      try { sound.ctx = new AC(); } catch (e) { return null; }
    }
    if (sound.ctx.state === "suspended") { const r = sound.ctx.resume(); if (r && r.catch) r.catch(() => {}); }
    return sound.ctx;
  }
  /* Everything runs through one gentle compressor so a busy moment never clips. */
  function out(c) {
    if (!sound.bus) {
      const comp = c.createDynamicsCompressor();
      comp.threshold.value = -16; comp.knee.value = 10; comp.ratio.value = 4; comp.attack.value = 0.002; comp.release.value = 0.16;
      const g = c.createGain(); g.gain.value = 0.9;
      comp.connect(g); g.connect(c.destination); sound.bus = comp;
    }
    return sound.bus;
  }
  function noise(c, secs, decay) {
    const b = c.createBuffer(1, Math.max(1, Math.floor(c.sampleRate * secs)), c.sampleRate);
    const d = b.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, decay);
    return b;
  }
  function burst(c, t, secs, decay, type, freq, q, gain) {
    const src = c.createBufferSource(); src.buffer = noise(c, secs, decay);
    const f = c.createBiquadFilter(); f.type = type; f.frequency.value = freq; f.Q.value = q;
    const g = c.createGain(); g.gain.value = gain;
    src.connect(f); f.connect(g); g.connect(out(c)); src.start(t);
    return f;
  }
  function tone(c, t, type, f0, f1, secs, gain) {
    const o = c.createOscillator(); o.type = type;
    o.frequency.setValueAtTime(f0, t); o.frequency.exponentialRampToValueAtTime(f1, t + secs);
    const g = c.createGain(); g.gain.setValueAtTime(gain, t); g.gain.exponentialRampToValueAtTime(0.0001, t + secs);
    o.connect(g); g.connect(out(c)); o.start(t); o.stop(t + secs + 0.02);
  }
  /* A struck acrylic bar: a short tick, a sine fundamental and the marimba-like overtone near four times it. */
  function bar(c, t, f, bright, gain) {
    const parts = bright ? [[1, 1, 0.5], [3.98, 0.3, 0.16], [9.92, 0.09, 0.06]] : [[1, 1, 0.62], [3.98, 0.14, 0.14]];
    for (const [m, a, d] of parts) {
      const o = c.createOscillator(); o.type = "sine"; o.frequency.value = f * m;
      const g = c.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(gain * a, t + 0.003);
      g.gain.exponentialRampToValueAtTime(0.0001, t + d);
      o.connect(g); g.connect(out(c)); o.start(t); o.stop(t + d + 0.03);
    }
    burst(c, t, 0.01, 3, "bandpass", bright ? 3600 : 2400, 2.2, gain * 0.3);
  }
  const SCALE = [0, 2, 4, 7, 9, 12, 14];                      // G major pentatonic, bottom slot to top
  const note = (slot, color, up) => (color === "Y" ? 392 : 196) * Math.pow(2, (SCALE[slot] + (up || 0)) / 12);
  const at = (c, ms) => c.currentTime + ms / 1000;

  function slideSound(ms) {   // the plate coming out: a ratchet that speeds up, over a faint scrape
    const c = audio(); if (!c) return;
    const t = c.currentTime, n = 9, len = Math.max(0.12, ms / 1000);
    const f = burst(c, t, len, 1.1, "bandpass", 900, 1.4, 0.035);
    f.frequency.setValueAtTime(900, t); f.frequency.exponentialRampToValueAtTime(2800, t + len);
    for (let i = 0; i < n; i++) { const k = i / n; burst(c, t + len * (1 - Math.pow(1 - k, 1.6)), 0.006, 2, "highpass", 4000 + 900 * k, 0.8, 0.05 + 0.03 * k); }
  }
  function clatter() {        // the stack hits the table: a thump and seven slabs knocking about
    const c = audio(); if (!c) return;
    const t = c.currentTime;
    tone(c, t, "sine", 150, 52, 0.16, 0.24);
    burst(c, t, 0.08, 3, "lowpass", 700, 0.7, 0.16);
    for (let i = 0; i < 7; i++) {
      const t0 = t + 0.015 + Math.random() * 0.17, f0 = 1500 + Math.random() * 2200, g0 = 0.06 + Math.random() * 0.06;
      burst(c, t0, 0.03, 5, "bandpass", f0, 4, g0);
      burst(c, t0 + 0.05 + Math.random() * 0.05, 0.02, 5, "bandpass", f0 * 1.06, 4, g0 * 0.45);
    }
  }
  function click() {          // the plate snaps back: click, then a small wooden tock
    const c = audio(); if (!c) return;
    const t = c.currentTime;
    burst(c, t, 0.012, 2, "highpass", 3800, 0.7, 0.09);
    burst(c, t + 0.028, 0.01, 2, "highpass", 4400, 0.7, 0.06);
    tone(c, t + 0.03, "triangle", 240, 150, 0.07, 0.07);
  }
  function tick() {           // the plate under a fingertip; only once sound has started
    const c = sound.ctx;
    if (!sound.on || !c || c.state !== "running") return;
    burst(c, c.currentTime, 0.006, 2, "highpass", 5200, 0.8, 0.045);
  }
  function clack(color, slot) { const c = audio(); if (!c) return; bar(c, c.currentTime, note(slot, color), color === "Y", 0.2); }
  function playOrder(s, gap) { // reduced motion: the tune without the fall
    const c = audio(); if (!c) return;
    for (let row = 6; row >= 0; row--) { const slot = 6 - row; bar(c, at(c, slot * gap), note(slot, s[row]), s[row] === "Y", 0.2); }
  }
  function winSound(s, top, rows) {  // a lock, then the winning yellows ring again low to high and land an octave up
    const c = audio(); if (!c) return;
    const slots = (rows && rows.length ? rows : fourRun(s)).slice().reverse().map((row) => 6 - row);
    burst(c, c.currentTime, 0.014, 2, "bandpass", 3000, 3, 0.1);
    burst(c, at(c, 50), 0.014, 2, "bandpass", 3300, 3, 0.08);
    slots.forEach((slot, i) => bar(c, at(c, 90 + i * 75), note(slot, "Y"), true, 0.17));
    const last = at(c, 90 + slots.length * 75 + 30), hi = note(slots[slots.length - 1], "Y", 12);
    bar(c, last, hi, true, 0.2);
    if (top) { bar(c, last + 0.15, hi * 1.5, true, 0.15); bar(c, last + 0.15, hi / 2, false, 0.14); }
  }
  function loseSound() {       // two low knocks, in no hurry
    const c = audio(); if (!c) return;
    bar(c, at(c, 40), 146.83, false, 0.17);
    bar(c, at(c, 250), 110, false, 0.16);
  }
  function hello() {           // sound back on: one yellow, one higher yellow
    const c = audio(); if (!c) return;
    bar(c, at(c, 0), note(0, "Y"), true, 0.16);
    bar(c, at(c, 90), note(3, "Y"), true, 0.15);
  }
  function renderSound() {
    document.querySelectorAll(".s4p .s4p-sound").forEach((b) => {
      b.textContent = sound.on ? "Sound on" : "Sound off";
      b.setAttribute("aria-pressed", String(sound.on));
    });
  }

  /* ---------- one lamp per section ---------- */
  function init(root) {
    if (root.dataset.s4pReady) return;
    root.dataset.s4pReady = "1";
    const q = (sel) => root.querySelector(sel);
    let G;
    try { G = JSON.parse(q("[data-s4p-geo]").textContent); } catch (e) { return; }

    const CW = G.crop[2], CH = G.crop[3];
    const VB = { x: -175, y: -230, w: CW + 175 + 95, h: CH + 230 };
    const [fx0, fy0, fx1, fy1] = G.face;
    const PITCH = (G.rows[6] - G.rows[0]) / 6;
    const restY = (r) => G.rows[r] - PITCH / 2;
    const START_Y = VB.y + 15;
    const GRAV = 11800;                       // photo pixels per second squared
    const fallMs = (d) => Math.sqrt((2 * d) / GRAV) * 1000;
    const MAXS = 120;                         // how far the plate slides out, in photo pixels
    const NUDGE = 12;                         // how far the plate gives under a hover, in photo pixels
    const BR = 34;                            // the bracket's outer edge, right of the face
    const COLOR = { Y: "#E2E472", R: "#BF001E" };
    const fracX = (x) => (x - VB.x) / VB.w, fracY = (y) => (y - VB.y) / VB.h;
    const TABY = (G.tab[1] + G.tab[3]) / 2;

    const stage = q(".s4p-stage"), lamp = q(".s4p-lamp"), fig = q(".s4p-fig"), slider = q(".s4p-slider"), bracket = q(".s4p-bracket");
    const colL = q(".s4p-side-l"), colR = q(".s4p-side-r"), leadTab = q(".s4p-lead"), result = q(".s4p-result");
    const title = q(".s4p-title"), wordL = q(".s4p-word-l"), lampTitle = q(".s4p-lamp-title");
    const btn = q(".s4p-pull"), label = q(".s4p-pull-label"), hit = q(".s4p-tab"), callout = q(".s4p-callout");
    const PRIZES = root.dataset.prizes === "on", UNTIL = root.dataset.until || "", LAMP = root.dataset.lamp || "/products/stack-4-lamp";
    /* Pulls for fun before the number box (theme setting): -1 = as many as they like, the box opens only from Make it count. */
    const FREE = PRIZES ? parseInt(root.dataset.free || "-1", 10) : 0;
    const countBtn = q(".s4p-count");
    const claim = q(".s4p-claim"), claimText = q(".s4p-claim-text"), claimLink = q(".s4p-claim-link");
    const caption = q(".s4p-caption");
    /* What this browser has done before: { at } after the number gate, plus the saved pull once gifts are on. */
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem("s4p-entry") || "null"); } catch (e) {}
    function attrs(n, a) { for (const k in a) n.setAttribute(k, a[k]); return n; }
    function el(name, a, parent) { const n = attrs(document.createElementNS(NS, name), a); if (parent) parent.appendChild(n); return n; }

    lamp.setAttribute("viewBox", VB.x + " " + VB.y + " " + VB.w + " " + VB.h);
    fig.style.aspectRatio = VB.w + " / " + VB.h;
    attrs(q(".s4p-interior"), { x: fx0 + 2, y: fy0 + 2, width: fx1 - fx0 - 4, height: fy1 - fy0 - 4 });
    attrs(q(".s4p-floor-rect"), { x: VB.x, y: VB.y, width: VB.w, height: G.floor - VB.y });
    attrs(q(".s4p-img-base"), { x: 0, y: 0, width: CW, height: CH });
    attrs(q(".s4p-img-shade"), { x: G.shade[0], y: G.shade[1], width: G.shade[2], height: G.shade[3] });
    attrs(q(".s4p-img-slider"), { x: G.slider[0], y: G.slider[1], width: G.slider[2], height: G.slider[3] });
    stage.style.setProperty("--body-top", fracY(0).toFixed(4));
    stage.style.setProperty("--row0", fracY(G.rows[0]).toFixed(4));
    stage.style.setProperty("--tabc", fracY(TABY).toFixed(4));

    /* The tab target and its phone callout, placed from the photo geometry. */
    const pct = (x, y) => [fracX(x) * 100, fracY(y) * 100];
    const [tx0, ty0] = pct(G.tab[0] - 50, G.tab[1] - 34), [tx1, ty1] = pct(G.tab[2] + 24, G.tab[3] + 42);
    Object.assign(hit.style, { left: tx0 + "%", top: ty0 + "%", width: tx1 - tx0 + "%", height: ty1 - ty0 + "%" });
    const [cx, cy] = pct(G.tab[0] - 6, TABY);
    Object.assign(callout.style, { left: cx + "%", top: cy + "%" });

    const slabs = [];
    for (let i = 0; i < 7; i++) {
      const g = el("g", {}, q(".s4p-slabs"));
      const rect = el("rect", { x: fx0 + 10, y: 0, width: fx1 - fx0 - 20, height: PITCH }, g);
      el("rect", { x: fx0 + 10, y: 0, width: fx1 - fx0 - 20, height: 4, fill: "#ffffff", "fill-opacity": 0.32 }, g);
      slabs.push({ g, rect, y: 0, row: 6 - i, color: "Y" });
    }
    function place(s, y) { s.y = y; s.g.setAttribute("transform", "translate(0 " + y.toFixed(2) + ")"); }
    function paint(s, c) { s.color = c; s.rect.setAttribute("fill", COLOR[c]); }
    function show(s, on) { s.g.style.visibility = on ? "visible" : "hidden"; }

    /* The plate, and the leader from the pull button into the tab: the leader shortens as the plate comes out. */
    let sx = 0, pxu = 0, leadW0 = 0;
    function setSlider(x) {
      sx = x; slider.setAttribute("transform", "translate(" + (-x).toFixed(2) + " 0)");
      if (pxu) leadTab.style.width = Math.max(0, leadW0 - x * pxu).toFixed(1) + "px";
    }

    const wait = (ms) => new Promise((res) => setTimeout(res, ms));
    function tween(ms, fn) {
      return new Promise((res) => {
        if (ms <= 0) { fn(1); res(); return; }
        const t0 = performance.now();
        function step(now) {
          const k = Math.min(1, (now - t0) / ms);
          fn(k);
          if (k < 1) requestAnimationFrame(step); else res();
        }
        requestAnimationFrame(step);
      });
    }
    const easeOut = (k) => 1 - Math.pow(1 - k, 3);
    const easeInOut = (k) => (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);

    /* Slab i rests in row 6 - i: the stack fills from the bottom. */
    function setOrder(s) {
      slabs.forEach((sl, i) => { const row = 6 - i; sl.row = row; paint(sl, s[row]); place(sl, restY(row)); show(sl, true); });
      describe(s);
    }
    function describe(s) { lampTitle.textContent = "Stack 4 Lamp. Slabs from top to bottom: " + words(s) + "."; }

    /* ---------- layout: the name fills its column, the notes sit level with the parts they name ---------- */
    function fitTitle() {
      if (!wide.matches) { title.style.removeProperty("--tsize"); return; }
      const H = fig.getBoundingClientRect().height;
      title.style.setProperty("--tsize", "100px");
      const natural = wordL.getBoundingClientRect().width;
      if (!natural || !H) return;
      const byWidth = (100 * colL.clientWidth) / natural;
      const byHeight = (fracY(TABY) * H - 28 - 56 - fracY(0) * H) / (2 * 0.78);
      title.style.setProperty("--tsize", Math.max(64, Math.floor(Math.min(byWidth, byHeight, 300))) + "px");
    }
    let lastKind = "aim", lastRows = [];
    function placeResult() {
      const H = fig.getBoundingClientRect().height;
      const mid = lastRows.length ? (G.rows[Math.min(...lastRows)] + G.rows[Math.max(...lastRows)]) / 2 : G.rows[3];
      const ry = fracY(mid) * H;
      colR.style.setProperty("--ry", ry.toFixed(1) + "px");
      /* A long result beside the bottom rows would run into the caption under it: lift it clear. */
      if (!wide.matches || !caption) return;
      const over = result.getBoundingClientRect().bottom - (caption.getBoundingClientRect().top - 18);
      if (over > 0) colR.style.setProperty("--ry", (ry - over).toFixed(1) + "px");
    }
    function layout() {
      fitTitle();
      if (!wide.matches) { leadTab.hidden = true; pxu = 0; return; }
      const sr = stage.getBoundingClientRect(), fr = fig.getBoundingClientRect(), br = btn.getBoundingClientRect(), cr = colR.getBoundingClientRect();
      if (!fr.width) return;
      pxu = fr.width / VB.w;
      colR.style.setProperty("--lead-face", Math.round(cr.left - (fr.left + fracX(fx1) * fr.width)) + "px");
      colR.style.setProperty("--lead-br", Math.round(cr.left - (fr.left + fracX(fx1 + BR) * fr.width)) + "px");
      const tabL = fr.left + fracX(G.tab[0]) * fr.width, ty = fr.top + fracY(TABY) * fr.height;
      leadW0 = tabL - br.right - 22;
      Object.assign(leadTab.style, { left: (br.right - sr.left + 14).toFixed(1) + "px", top: (ty - sr.top).toFixed(1) + "px" });
      leadTab.hidden = leadW0 < 28;
      setSlider(sx);
      placeResult();
    }

    /* ---------- result: the bracket marks the rows on the lamp, the words sit beside them ---------- */
    function showBracket(rows) {
      const y1 = G.rows[Math.min(...rows)] - G.R - 8, y2 = G.rows[Math.max(...rows)] + G.R + 8, x = fx1 + BR, t = fx1 + 16;
      bracket.setAttribute("d", "M" + t + " " + y1 + "H" + x + "V" + y2 + "H" + t);
      bracket.classList.remove("is-on");
      bracket.getBoundingClientRect();
      requestAnimationFrame(() => bracket.classList.add("is-on"));
    }
    function hideBracket() { bracket.classList.remove("is-on"); }
    function readout(k, head, text) {
      result.dataset.kind = k;
      q(".s4p-ro-title").textContent = head; q(".s4p-ro-text").textContent = text;
    }
    const state = (s) => { stage.dataset.state = s; };

    let current = START, busy = false, drag = null, pulls = 0, touched = false;
    let nudgeTarget = 0, nudging = false;
    let markMatrix = () => {};
    /* The line under a result once gifts are on: where the gift is saved, and the way to the lamp. */
    function showClaim(info, first) {
      if (!claim) return;
      if (!PRIZES || !info || !info.gift || (info.gift === "none" && !first)) { claim.hidden = true; return; }
      const masked = info.last4 ? "\u2022\u2022\u2022\u2022" + info.last4 : "your number";
      const until = UNTIL || info.until || "";
      const tag = info.no ? "Pull #" + String(info.no).padStart(4, "0") + ". " : "";
      let t;
      if (info.gift === "none") t = tag + "This number has pulled. Every pull from here is for fun.";
      else if (info.gift === "rs444") t = tag + (info.code ? "Code " + info.code + " takes Rs. 444 off the lamp, once, until " + until + "." : "Your Rs. 444 code comes on WhatsApp. Locked to " + masked + " until " + until + ".");
      else t = tag + "Locked to " + masked + " until " + until + ". Order the lamp on this number and it comes in the same box.";
      claimText.textContent = t;
      claimLink.textContent = info.gift === "none" ? "See the lamp" : "Get the lamp";
      claimLink.href = LAMP;
      claim.hidden = false;
    }
    function finish(s, counted, prize) {
      const n = pad(orderNo(s));
      if (counted) pulls++;
      let k, rows;
      if (PRIZES) {
        const g = giftOf(s);
        rows = runOf(s);
        k = g === "spring-stand" ? "top" : rows.length ? "down" : "none";
        if (prize) {
          readout(k, GIFT[g].head, "Order " + n + " / 35. " + GIFT[g].ships);
          if (saved) { saved.played = true; try { localStorage.setItem("s4p-entry", JSON.stringify(saved)); } catch (e) {} }
        } else if (gate && !unlocked) {
          /* Free play before a number: say what it would have been, and how to make one count. */
          const would = g !== "none" ? " That would have been " + GIFT[g].name + "." : "";
          readout(k, "For fun.", "Order " + n + " / 35, " + SHAPE[g] + "." + would + " Leave your number and the next pull counts.");
        } else {
          /* Every pull after the one that counts says so in the headline, not in the small print. */
          const mine = saved && saved.gift;
          const keep = mine && mine !== "none" && GIFT[mine] ? "Your " + (mine === "rs444" ? "Rs. 444 off" : GIFT[mine].label) + " is locked in."
            : mine === "none" ? "Your number has had its pull. This one is for the tune."
            : "Nothing is drawn on this pull.";
          readout(k, "For fun.", "Order " + n + " / 35, " + SHAPE[g] + ". " + keep);
        }
        showClaim(saved, !!prize);
      } else {
        k = kind(s);
        rows = fourRun(s);
        if (k === "top") readout(k, "Four on top.", "Order " + n + " / 35. The one order with all four yellows at the top.");
        else if (k === "down") readout(k, "Four in a row.", "Order " + n + " / 35. Four yellows together.");
        else readout(k, "Not this round.", "Order " + n + " / 35.");
      }
      lastKind = k; lastRows = rows;
      lastSlip = {
        s, n: orderNo(s), rows: rows.slice(), fun: PRIZES && !prize, at: prize && prize.at ? prize.at : Date.now(), no: prize && prize.no ? prize.no : null,
        shape: PRIZES ? SHAPE[giftOf(s)] : k === "top" ? "four on top" : k === "down" ? "four in a row" : "nothing lined up",
        giftLabel: PRIZES && prize ? SLIP_GIFT[giftOf(s)] : null, giftName: PRIZES && prize ? GIFT[giftOf(s)].name : "",
      };
      if (slipOpen) slipOpen.hidden = false;
      showBuy();
      if (rows.length) showBracket(rows); else hideBracket();
      placeResult();
      label.textContent = PRIZES ? "Pull for fun" : pulls ? "Pull again" : "Pull the tab";
      describe(s); markMatrix(s);
      state("result");
    }
    function setBusy(on) {
      busy = on; btn.disabled = on; hit.classList.toggle("is-busy", on);
      if (on) { state("busy"); label.textContent = "Dropping"; }
    }

    function dropSlab(s, row) {
      const y1 = restY(row), dist = y1 - START_Y;
      place(s, START_Y); show(s, true);
      return tween(fallMs(dist), (k) => place(s, START_Y + dist * k * k)).then(() => {
        clack(s.color, 6 - row);
        return tween(150, (k) => place(s, y1 - (k < 0.55 ? 9 * Math.sin((Math.PI * k) / 0.55) : 2.5 * Math.sin((Math.PI * (k - 0.55)) / 0.45))));
      }).then(() => place(s, y1));
    }

    async function pull(prize) {
      if (busy) return;
      touched = true; nudgeTarget = 0; callout.classList.add("is-gone");
      setBusy(true); hideBracket();
      /* The pull that counts plays back the order the leads worker drew; every other pull draws here. */
      const next = prize && ORDERS.includes(prize.order) ? prize.order : ORDERS[randIndex(ORDERS.length)];
      const fast = reduce.matches;

      /* 1. the plate slides out */
      const from = sx, slideMs = fast ? 0 : 240 * (1 - from / MAXS);
      slideSound(slideMs || 120);
      await tween(slideMs, (k) => setSlider(from + (MAXS - from) * easeOut(k)));
      /* 2. the bottom is open: the whole stack drops out together */
      if (fast) { clatter(); slabs.forEach((s) => show(s, false)); }
      else {
        const ys = slabs.map((s) => s.y), D = 1850;
        setTimeout(clatter, 230);
        await tween(fallMs(D), (k) => { const d = D * k * k; slabs.forEach((s, i) => place(s, ys[i] + d)); });
        slabs.forEach((s) => show(s, false));
      }
      /* 3. the plate goes back */
      click();
      await tween(fast ? 0 : 200, (k) => setSlider(MAXS * (1 - easeInOut(k))));
      if (!fast) await wait(140);
      /* 4. seven slabs go back in from the top, bottom row first */
      if (fast) {
        setOrder(next);
        playOrder(next, 70);
      } else {
        const drops = []; let t = 0;
        for (let i = 0; i < 7; i++) {
          const s = slabs[i], row = 6 - i;
          s.row = row; paint(s, next[row]); show(s, false);
          if (i === 6) t += 160;
          drops.push(wait(t).then(() => dropSlab(s, row)));
          t += 0.6 * fallMs(restY(row) - START_Y);
        }
        await Promise.all(drops);
      }
      current = next;
      /* 5. a win settles its yellows once more and plays them back; a miss knocks twice */
      const rows = PRIZES ? runOf(next) : fourRun(next);
      const kd = !rows.length ? "none" : next === TOP ? "top" : "down";
      if (kd !== "none" && !fast) {
        await wait(90);
        winSound(next, kd === "top", rows);
        const settle = slabs.filter((s) => rows.includes(s.row));
        await tween(110, (p) => settle.forEach((s) => place(s, restY(s.row) + 3 * Math.sin(Math.PI * p))));
        settle.forEach((s) => place(s, restY(s.row)));
      } else if (kd !== "none") setTimeout(() => winSound(next, kd === "top", rows), 7 * 70 + 60);
      else setTimeout(loseSound, fast ? 7 * 70 + 60 : 80);
      setBusy(false);
      finish(next, true, prize && ORDERS.includes(prize.order) ? prize : null);
    }
    /* ---------- the number gate: a phone and WhatsApp number before the first pull ---------- */
    const gate = q(".s4p-gate");
    const form = gate && gate.querySelector(".s4p-gate-form");
    const loadedAt = Date.now();
    let unlocked = !gate || typeof gate.showModal !== "function";
    /* With gifts on, a browser that only passed the demo gate asks once more, so its number gets the pull that counts. */
    if (!unlocked) unlocked = !!saved && (!PRIZES || !!saved.gift);
    let sending = false;

    /* The same rules as the leads worker: E.164, or '' when the number cannot be real. */
    function e164(raw) {
      const s = String(raw || "").trim();
      if (!s) return "";
      const digits = s.replace(/\D/g, "");
      if (s.startsWith("+")) {
        if (digits.startsWith("91")) return /^91[6-9]\d{9}$/.test(digits) ? "+" + digits : "";
        return digits.length >= 8 && digits.length <= 15 ? "+" + digits : "";
      }
      let d = digits;
      if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
      else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
      return /^[6-9]\d{9}$/.test(d) ? "+91" + d : "";
    }

    function openGate() {
      if (!gate || gate.open) return;
      gate.querySelector(".s4p-gate-err").hidden = true;
      gate.showModal();
      setTimeout(() => form.elements.phone.focus(), 30);
    }
    /* The order the leads worker drew waits for the customer's own pull; the page never pulls for them. */
    let pending = null;
    function unlock(prize, phone) {
      unlocked = true;
      saved = { at: Date.now() };
      if (prize) Object.assign(saved, { gift: prize.gift, n: prize.n, order: prize.order, until: prize.until, code: prize.code || null, last4: String(phone || "").slice(-4), played: false, no: prize.no || null, pulledAt: prize.at || null });
      try { localStorage.setItem("s4p-entry", JSON.stringify(saved)); } catch (e) {}
      pending = prize || null;
      gate.close();
      const aim = q(".s4p-note-aim");
      if (aim) aim.textContent = pending ? "You're in. This pull counts." : "You're in. Pull the tab.";
      label.textContent = pending ? "Pull for real" : "Pull the tab";
      showCount();
      btn.focus({ preventScroll: true });
    }
    function pullNow() {
      if (busy) return;
      const p = pending; pending = null;
      pull(p || undefined);
    }
    let freePulls = 0;
    try { freePulls = parseInt(localStorage.getItem("s4p-free") || "0", 10) || 0; } catch (e) {}
    const freeLeft = () => PRIZES && !unlocked && (FREE < 0 || freePulls < FREE);
    function pullAction() {
      if (busy) return;
      if (unlocked) { pullNow(); return; }
      if (freeLeft()) {
        freePulls++;
        try { localStorage.setItem("s4p-free", String(freePulls)); } catch (e) {}
        pull();
        return;
      }
      openGate();
    }
    function tryPull() { pullAction(); }
    function showCount() { if (countBtn) countBtn.hidden = !(PRIZES && gate && !unlocked); }
    if (countBtn) countBtn.addEventListener("click", () => { if (!busy) openGate(); });
    showCount();

    if (gate && !unlocked) {
      const err = gate.querySelector(".s4p-gate-err"), goBtn = gate.querySelector(".s4p-gate-go"), goLabel = gate.querySelector(".s4p-gate-go-label");
      const same = form.elements.whatsapp_same, waRow = gate.querySelector(".s4p-wa");
      const fail = (msg, field) => {
        err.textContent = msg; err.hidden = false;
        if (field) { if (field.type !== "checkbox") field.setAttribute("aria-invalid", "true"); field.focus(); }
      };
      same.addEventListener("change", () => { waRow.hidden = same.checked; if (!same.checked) form.elements.whatsapp.focus(); });
      gate.querySelector(".s4p-gate-close").addEventListener("click", () => gate.close());
      gate.addEventListener("click", (e) => { if (e.target === gate) gate.close(); });
      gate.addEventListener("close", () => { if (!unlocked) btn.focus(); });
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (sending) return;
        const phoneIn = form.elements.phone, waIn = form.elements.whatsapp, consentIn = form.elements.whatsapp_consent;
        phoneIn.removeAttribute("aria-invalid"); waIn.removeAttribute("aria-invalid");
        const phone = e164(phoneIn.value);
        if (!phone) { fail("Enter your 10-digit mobile number.", phoneIn); return; }
        const wa = same.checked ? phone : e164(waIn.value);
        if (!wa) { fail("Enter your WhatsApp number, or tick 'WhatsApp is on this number'.", waIn); return; }
        if (!consentIn.checked) { fail("Tick the box so we can message you on WhatsApp.", consentIn); return; }
        sending = true; err.hidden = true; goBtn.disabled = true; goLabel.textContent = "Saving";
        try {
          const res = await fetch(form.dataset.endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              phone, whatsapp: wa, whatsapp_same: same.checked, whatsapp_consent: true, want_pull: PRIZES,
              company_website: form.elements.company_website.value, s4p_ts: loadedAt, page_url: location.href,
            }),
          });
          let data = null;
          try { data = await res.json(); } catch (x) {}
          if (res.ok && data && data.ok) { unlock(PRIZES && data.prizes && data.pull ? data.pull : null, phone); return; }
          const code = data && data.error;
          fail(code === "invalid_phone" ? "That phone number doesn't look right."
            : code === "invalid_whatsapp" ? "That WhatsApp number doesn't look right."
            : code === "consent_required" ? "Tick the box so we can message you on WhatsApp."
            : code === "rate_limited" ? "One moment, then try again."
            : code === "try_again" ? "We couldn't save your pull. Try again in a moment."
            : "We couldn't save your number. Try again in a moment.");
        } catch (x) {
          fail("We couldn't reach NOTICE. Check your connection and try again.");
        } finally {
          sending = false; goBtn.disabled = false; goLabel.textContent = "Unlock the pull";
        }
      });
    }

    btn.addEventListener("click", tryPull);

    /* The plate gives a little under the pointer, the way a tab does under a fingertip. */
    function nudgeLoop() {
      if (busy || drag) { nudging = false; return; }
      const d = nudgeTarget - sx;
      if (Math.abs(d) < 0.2) { setSlider(nudgeTarget); nudging = false; return; }
      setSlider(sx + d * 0.22);
      requestAnimationFrame(nudgeLoop);
    }
    function nudge(on) {
      if (reduce.matches || busy || drag) return;
      if (on && nudgeTarget !== NUDGE) tick();
      nudgeTarget = on ? NUDGE : 0;
      if (!nudging) { nudging = true; requestAnimationFrame(nudgeLoop); }
    }
    [btn, hit].forEach((n) => {
      n.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") nudge(true); });
      n.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse") nudge(false); });
      n.addEventListener("focus", () => nudge(true));
      n.addEventListener("blur", () => nudge(false));
    });

    /* Drag the NOTICE tab out like the real plate. A tap pulls too; Enter or Space on the tab pulls. */
    function unitsPerPx() { const r = lamp.getBoundingClientRect(); return r.width ? VB.w / r.width : 1; }
    hit.addEventListener("pointerdown", (e) => {
      if (busy) return;
      if (!unlocked && !freeLeft()) { e.preventDefault(); openGate(); return; }
      touched = true; audio();
      drag = { x: e.clientX, y: e.clientY, d: 0, s: unitsPerPx(), id: e.pointerId, moved: false, tick: 0 };
      try { hit.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    hit.addEventListener("pointermove", (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const dx = (drag.x - e.clientX) * drag.s, dy = (e.clientY - drag.y) * drag.s * 0.6;
      const d = Math.max(0, Math.min(MAXS, Math.max(dx, dy)));
      if (d > 6 && !drag.moved) { drag.moved = true; callout.classList.add("is-gone"); }
      if (Math.abs(d - drag.tick) >= 14) { drag.tick = d; tick(); }
      drag.d = d; setSlider(d);
    });
    hit.addEventListener("pointerup", (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const d = drag.d, moved = drag.moved; drag = null;
      if (!moved || d > MAXS * 0.45) { pullAction(); return; }
      const from = sx;
      tween(reduce.matches ? 0 : 180, (k) => setSlider(from * (1 - easeOut(k))));
    });
    hit.addEventListener("pointercancel", () => { if (!drag) return; drag = null; setSlider(0); });
    hit.addEventListener("click", (e) => { if (e.detail === 0) tryPull(); });

    /* The poster's button brings the lamp into view below the site header. */
    const cta = q(".s4p-open-cta");
    if (cta) cta.addEventListener("click", (e) => {
      if (cta.closest(".is-splash")) return;           /* the loading screen handles its own button */
      e.preventDefault(); stage.scrollIntoView({ behavior: reduce.matches ? "auto" : "smooth", block: "start" });
    });

    q(".s4p-sound").addEventListener("click", () => {
      sound.on = !sound.on;
      try { localStorage.setItem("s4pull-sound", sound.on ? "on" : "off"); } catch (e) {}
      renderSound();
      if (sound.on) hello();
    });

    let layoutQueued = false;
    const queueLayout = () => { if (layoutQueued) return; layoutQueued = true; requestAnimationFrame(() => { layoutQueued = false; layout(); }); };
    window.addEventListener("resize", queueLayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueLayout);
    if (window.ResizeObserver) new ResizeObserver(queueLayout).observe(stage);

    /* ---------- the manual: the four winning orders, then all 35 as one technical strip ---------- */
    const wins = q(".s4p-wins"), M = q(".s4p-matrix");
    if (wins) {
      /* Demo: the four winning orders. Gifts: one order for each gift. */
      const shown = PRIZES ? [TOP, "RRYYYYR", "YYYRYRR", ALT] : ORDERS.filter((s) => kind(s) !== "none");
      shown.forEach((s) => {
        const i = ORDERS.indexOf(s), k = kind(s), rows = PRIZES ? runOf(s) : fourRun(s);
        const f = document.createElement("figure"); f.className = "s4p-win";
        const mini = document.createElement("div"); mini.className = "s4p-mini"; mini.setAttribute("role", "img"); mini.setAttribute("aria-label", "Order " + pad(i + 1) + ": " + words(s));
        const col = document.createElement("span");
        for (const c of s) { const cell = document.createElement("i"); cell.className = c === "Y" ? "y" : "r"; col.appendChild(cell); }
        const brk = document.createElement("b"); const lo = Math.min(...rows), hi = Math.max(...rows);
        brk.style.marginTop = lo * 13 + "px"; brk.style.height = (hi - lo + 1) * 13 - 3 + "px"; brk.style.alignSelf = "flex-start";
        mini.append(col, brk);
        const cap = document.createElement("figcaption");
        cap.textContent = PRIZES ? "Order " + pad(i + 1) + " / " + GIFT[giftOf(s)].label : "Order " + pad(i + 1) + (k === "top" ? " / Four on top" : "");
        f.append(mini, cap);
        wins.appendChild(f);
      });
    }
    if (M) {
      const CELL = 10, GAP = 2, MW = 35 * (CELL + GAP) - GAP, MH = 7 * (CELL + GAP) - GAP;
      M.setAttribute("viewBox", "-3 -3 " + (MW + 6) + " " + (MH + 28));
      ORDERS.forEach((s, i) => {
        const x = i * (CELL + GAP);
        for (let r = 0; r < 7; r++) el("rect", { x, y: r * (CELL + GAP), width: CELL, height: CELL, fill: COLOR[s[r]] }, M);
        if ((PRIZES ? giftOf(s) : kind(s)) !== "none") el("rect", { x, y: MH + 5, width: CELL, height: 1.6, fill: "#121212" }, M);
        if (i === 0 || (i + 1) % 5 === 0) { const tx = el("text", { x: x + CELL / 2, y: MH + 19, "text-anchor": "middle" }, M); tx.textContent = pad(i + 1); }
      });
      const cur = el("rect", { y: -2.5, width: CELL + 5, height: MH + 5, fill: "none", stroke: "#121212", "stroke-width": 1.2 }, M);
      markMatrix = (s) => cur.setAttribute("x", (orderNo(s) - 1) * (CELL + GAP) - 2.5);
    }

    /* ---------- the opening as a loading screen: the slabs fill as the game loads, then the poster is pulled away ---------- */
    const opening = q(".s4p-open");
    if (opening && opening.classList.contains("is-splash")) {
      opening.dataset.s4pBound = "1";
      const segs = Array.from(opening.querySelectorAll(".s4p-load-bar i"));
      const loadText = opening.querySelector(".s4p-load-text");
      const arrow = opening.querySelector(".s4p-open-cta-arrow");
      if (arrow) arrow.textContent = "\u2190";
      const behind = [stage, q(".s4p-manual"), q(".s4p-terms")].filter(Boolean);
      behind.forEach((n) => n.setAttribute("inert", ""));

      const t0 = performance.now(), MIN = reduce.matches ? 300 : 1400, CAP = 6000;
      const waits = Array.from(root.querySelectorAll(".s4p-lamp image"))
        .map((im) => im.getAttribute("href")).filter(Boolean)
        .map((u) => new Promise((res) => { const i = new Image(); i.onload = i.onerror = res; i.src = u; }));
      const poster = opening.querySelector(".s4p-poster");
      let posterDone = !poster || poster.complete;
      if (!posterDone) waits.push(new Promise((res) => { poster.addEventListener("load", res, { once: true }); poster.addEventListener("error", res, { once: true }); }).then(() => { posterDone = true; }));
      if (document.fonts && document.fonts.ready) waits.push(document.fonts.ready);
      let loaded = 0, lit = 0, isReady = false, leaving = false;
      waits.forEach((w) => w.then(() => { loaded++; }));
      const total = Math.max(1, waits.length);

      const fill = () => {
        const t = performance.now() - t0;
        const byLoad = t > CAP ? 7 : Math.floor((loaded / total) * 7);
        const byTime = Math.floor((t / MIN) * 7);
        let target = Math.min(7, byLoad, byTime);
        /* never say Ready over a poster that has not arrived (15 s after navigation as a last resort) */
        if (target >= 7 && !posterDone && performance.now() < 15000) target = 6;
        while (lit < target) segs[lit++].classList.add("is-on");
        if (lit >= 7) { ready(); return; }
        requestAnimationFrame(fill);
      };
      const ready = () => {
        if (isReady) return;
        isReady = true;
        if (loadText) loadText.textContent = "Ready";
        opening.classList.add("is-ready");
        setTimeout(() => { if (cta) cta.focus({ preventScroll: true }); }, 60);
      };
      const leave = () => {
        if (leaving) return;
        leaving = true;
        try { sessionStorage.setItem("s4p-splash-seen", "1"); } catch (e) {}
        slideSound(520);                                  /* this tap also unlocks the page's sound */
        opening.classList.add("is-out");
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          opening.classList.remove("is-splash", "is-ready", "is-out");
          opening.classList.add("is-gone");
          document.documentElement.classList.remove("s4p-lock");
          behind.forEach((n) => n.removeAttribute("inert"));
          window.scrollTo(0, 0);
          queueLayout();
          btn.focus({ preventScroll: true });
        };
        if (reduce.matches) setTimeout(finish, 170);
        else { opening.addEventListener("transitionend", finish, { once: true }); setTimeout(finish, 900); }
      };
      if (cta) cta.addEventListener("click", (e) => { e.preventDefault(); if (isReady) leave(); });
      opening.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && isReady) leave();
        if (e.key === "Tab") { e.preventDefault(); if (cta && isReady) cta.focus(); }   /* the page behind is covered */
      });
      requestAnimationFrame(fill);
    }

    /* ---------- the slip: a numbered card for each pull, drawn here, to post or save (13 Oct) ---------- */
    const slipDlg = q(".s4p-slip"), slipOpen = q(".s4p-slip-open");
    const slipImg = slipDlg && slipDlg.querySelector(".s4p-slip-img"), slipShare = slipDlg && slipDlg.querySelector(".s4p-slip-share"), slipSave = slipDlg && slipDlg.querySelector(".s4p-slip-save");
    const SLIP = { top: "#2445BE", bottom: "#172E86", face: "#10256F", paper: "#FFFDF8", soft: "rgba(255,253,248,.7)", ink: "#121212", Y: COLOR.Y, R: COLOR.R };
    const SLIP_GIFT = { "spring-stand": "SPRING STAND", tetrapod: "TETRAPOD", sutli: "SUTLI CANDLE HOLDER", rs444: "RS. 444 OFF", none: "NO GIFT" };
    const LOGO_D = ["M43.3959 24.9968C43.3528 24.9968 43.3139 24.9732 43.293 24.9357L31.1154 3.16728L31.1655 3.15895V24.8788C31.1655 24.9441 31.1127 24.9968 31.0473 24.9968H27.8378C27.7724 24.9968 27.7196 24.9441 27.7196 24.8788V1.12119C27.7196 1.05595 27.7724 1.0032 27.8378 1.0032H33.8869C33.93 1.0032 33.969 1.0268 33.9898 1.06428L45.664 21.9277L45.6139 21.9443V1.12119C45.6139 1.05595 45.6668 1.0032 45.7321 1.0032H48.9417C49.007 1.0032 49.0599 1.05595 49.0599 1.12119V24.8788C49.0599 24.9441 49.007 24.9968 48.9417 24.9968H43.3959Z", "M50.6901 9.48945C50.9363 8.39006 51.2937 7.37812 51.7623 6.45225C52.2296 5.52638 52.7969 4.69628 53.4644 3.96058C54.1305 3.22487 54.8842 2.60161 55.7255 2.08939C56.5655 1.57718 57.4847 1.18434 58.4817 0.910883C59.4788 0.637424 60.5412 0.5 61.6676 0.5C62.794 0.5 63.8551 0.637424 64.8535 0.910883C65.8506 1.18434 66.7698 1.57718 67.6097 2.08939C68.4496 2.60161 69.2047 3.22487 69.875 3.96058C70.5439 4.69628 71.1113 5.52638 71.5771 6.45225C72.0416 7.37812 72.399 8.39006 72.6493 9.48945C72.8982 10.5888 73.0233 11.759 73.0233 13C73.0233 14.241 72.8982 15.4125 72.6493 16.5105C72.4004 17.6099 72.043 18.6219 71.5771 19.5478C71.1126 20.4736 70.5453 21.3037 69.875 22.0394C69.2047 22.7751 68.451 23.3984 67.6097 23.9106C66.7698 24.4228 65.8506 24.8157 64.8535 25.0891C63.8564 25.3626 62.794 25.5 61.6676 25.5C60.5412 25.5 59.4802 25.3626 58.4817 25.0891C57.4847 24.8157 56.5655 24.4214 55.7255 23.9106C54.8856 23.3984 54.1319 22.7751 53.4644 22.0394C52.7969 21.3037 52.2296 20.4736 51.7623 19.5478C51.2951 18.6219 50.9377 17.6099 50.6901 16.5105C50.444 15.4112 50.3202 14.241 50.3202 13C50.3202 11.759 50.444 10.5875 50.6901 9.48945ZM54.0888 15.6846C54.2487 16.5119 54.4823 17.2685 54.7911 17.9542C55.0998 18.6399 55.478 19.2479 55.9258 19.7796C56.3736 20.3112 56.8881 20.7582 57.468 21.1219C58.0479 21.4856 58.6889 21.7604 59.3926 21.9478C60.0962 22.1352 60.8541 22.2282 61.6662 22.2282C62.4784 22.2282 63.2362 22.1352 63.9399 21.9478C64.6435 21.7604 65.2846 21.4856 65.8645 21.1219C66.4444 20.7582 66.9603 20.3112 67.4108 19.7796C67.8614 19.2479 68.241 18.6399 68.5497 17.9542C68.8585 17.2685 69.0921 16.5119 69.252 15.6846C69.4119 14.8573 69.4912 13.962 69.4912 13C69.4912 12.038 69.4119 11.1427 69.252 10.3154C69.0921 9.48806 68.8585 8.73154 68.5497 8.04581C68.241 7.36008 67.8614 6.75208 67.4108 6.22043C66.9603 5.68878 66.4444 5.24181 65.8645 4.87812C65.2846 4.51444 64.6435 4.23959 63.9399 4.05219C63.2362 3.8648 62.4784 3.77179 61.6662 3.77179C60.8541 3.77179 60.0962 3.8648 59.3926 4.05219C58.6889 4.23959 58.0479 4.51444 57.468 4.87812C56.8881 5.24181 56.3736 5.68878 55.9258 6.22043C55.478 6.75208 55.0998 7.36008 54.7911 8.04581C54.4823 8.73154 54.2487 9.48806 54.0888 10.3154C53.9289 11.1427 53.8496 12.038 53.8496 13C53.8496 13.962 53.9289 14.8573 54.0888 15.6846Z", "M92.7717 4.27499H84.6019C84.4962 4.27499 84.4433 4.14729 84.5184 4.07372C84.5935 3.99876 84.7201 4.05151 84.7201 4.157V24.8788C84.7201 24.9441 84.6672 24.9968 84.6019 24.9968H81.3089C81.2435 24.9968 81.1907 24.9441 81.1907 24.8788V4.157C81.1907 4.05151 81.3186 3.99876 81.3923 4.07372C81.4674 4.14867 81.4146 4.27499 81.3089 4.27499H73.1391C73.0737 4.27499 73.0209 4.22225 73.0209 4.157V1.12119C73.0209 1.05595 73.0737 1.0032 73.1391 1.0032H92.7717C92.8371 1.0032 92.8899 1.05595 92.8899 1.12119V4.157C92.8899 4.22225 92.8371 4.27499 92.7717 4.27499Z", "M97.8127 24.9968H94.5197C94.4543 24.9968 94.4015 24.9441 94.4015 24.8788V1.12119C94.4015 1.05595 94.4543 1.0032 94.5197 1.0032H97.8127C97.878 1.0032 97.9309 1.05595 97.9309 1.12119V24.8788C97.9309 24.9441 97.878 24.9968 97.8127 24.9968Z", "M102.969 15.6846C103.129 16.5119 103.363 17.2685 103.671 17.9542C103.979 18.6399 104.358 19.2479 104.806 19.7796C105.254 20.3112 105.768 20.7582 106.348 21.1219C106.928 21.4856 107.568 21.7604 108.269 21.9478C108.97 22.1352 109.726 22.2282 110.538 22.2282C111.524 22.2282 112.42 22.088 113.223 21.809C114.027 21.53 114.735 21.1135 115.345 20.5625C115.956 20.0114 116.469 19.3284 116.883 18.5108C117.285 17.7182 117.587 16.8076 117.79 15.779C117.801 15.7235 117.849 15.6832 117.906 15.6832H121.207C121.281 15.6832 121.336 15.7499 121.324 15.822C121.068 17.299 120.641 18.626 120.04 19.8032C119.421 21.0164 118.647 22.0464 117.716 22.8903C116.786 23.7343 115.717 24.3812 114.506 24.8281C113.296 25.2751 111.97 25.5 110.53 25.5C109.409 25.5 108.351 25.3626 107.352 25.0891C106.355 24.8157 105.437 24.4214 104.6 23.9106C103.763 23.3984 103.009 22.7751 102.339 22.0394C101.669 21.3037 101.101 20.4736 100.637 19.5478C100.173 18.6219 99.8165 17.6099 99.569 16.5105C99.3229 15.4112 99.1991 14.241 99.1991 13C99.1991 11.759 99.3229 10.5875 99.569 9.48945C99.8151 8.39006 100.171 7.37812 100.637 6.45225C101.101 5.52638 101.669 4.69628 102.339 3.96058C103.008 3.22487 103.762 2.60161 104.6 2.08939C105.437 1.57718 106.355 1.18434 107.352 0.910883C108.349 0.637424 109.409 0.5 110.53 0.5C111.969 0.5 113.294 0.723487 114.506 1.17185C115.715 1.61882 116.786 2.26569 117.716 3.10966C118.647 3.95364 119.421 4.98362 120.04 6.19684C120.641 7.37396 121.068 8.701 121.324 10.178C121.336 10.2501 121.281 10.3168 121.207 10.3168H117.906C117.849 10.3168 117.801 10.2765 117.79 10.221C117.589 9.19239 117.287 8.28179 116.883 7.48917C116.469 6.67296 115.956 5.98862 115.345 5.43753C114.735 4.88645 114.027 4.4714 113.223 4.191C112.42 3.91199 111.524 3.77179 110.538 3.77179C109.726 3.77179 108.97 3.8648 108.269 4.05219C107.568 4.23959 106.928 4.51444 106.348 4.87812C105.768 5.24181 105.254 5.68878 104.806 6.22043C104.358 6.75208 103.98 7.36008 103.671 8.04581C103.363 8.73154 103.129 9.48806 102.969 10.3154C102.809 11.1427 102.73 12.038 102.73 13C102.73 13.962 102.809 14.8573 102.969 15.6846Z", "M139.081 1.12119V4.157C139.081 4.22225 139.028 4.27499 138.962 4.27499H126.247C126.142 4.27499 126.09 4.15006 126.162 4.0751L126.17 4.06678C126.244 3.99043 126.373 4.04179 126.373 4.14867V11.5154C126.373 11.6223 126.244 11.6737 126.17 11.5973L126.162 11.589C126.09 11.514 126.142 11.3891 126.247 11.3891H137.954C138.02 11.3891 138.072 11.4418 138.072 11.5071V14.5429C138.072 14.6081 138.02 14.6609 137.954 14.6609H126.247C126.142 14.6609 126.09 14.536 126.162 14.461L126.17 14.4527C126.244 14.3763 126.373 14.4277 126.373 14.5346V21.8513C126.373 21.9582 126.244 22.0096 126.17 21.9332L126.162 21.9249C126.09 21.85 126.142 21.725 126.247 21.725H139.299C139.364 21.725 139.417 21.7778 139.417 21.843V24.8788C139.417 24.9441 139.364 24.9968 139.299 24.9968H122.962C122.897 24.9968 122.844 24.9441 122.844 24.8788V1.12119C122.844 1.05595 122.897 1.0032 122.962 1.0032H138.964C139.029 1.0032 139.082 1.05595 139.082 1.12119H139.081Z", "M24.6479 1.44402V24.5562C24.6479 24.8074 24.4435 25.0115 24.1918 25.0115H22.238V16.3344C22.2241 12.356 18.9993 9.13281 15.0166 9.11615H12.6122C12.4495 9.11615 12.3688 8.92043 12.4829 8.80521L14.1836 7.10754C14.3616 6.92986 14.3616 6.64114 14.1836 6.46346L11.4274 3.71221C11.2494 3.53453 10.9602 3.53453 10.7822 3.71221L3.31041 11.1706C3.13241 11.3482 3.13241 11.637 3.31041 11.8147L10.7822 19.273C10.9602 19.4507 11.248 19.4507 11.426 19.273L14.1822 16.5231C14.3602 16.3455 14.3602 16.0567 14.1822 15.8791L12.5635 14.2633C12.4481 14.1481 12.5302 13.9524 12.6929 13.9524H15.0207C16.3516 13.9524 17.4293 15.0281 17.4293 16.3566V25.0115H1.03815C0.786451 25.0115 0.582031 24.8074 0.582031 24.5562V1.44402C0.582031 1.19277 0.786451 0.988721 1.03815 0.988721H24.1918C24.4435 0.988721 24.6479 1.19277 24.6479 1.44402Z"];
    let lastSlip = null, slipFmt = "story", slipFile = null, slipUrl = "", slipJob = 0;
    const slipFont = (px, bold) => (bold ? "700 " + px + 'px Nohemi, "Helvetica Neue", Arial, sans-serif' : px + 'px nohemimedium, Nohemi, "Helvetica Neue", Arial, sans-serif');
    function slipFonts() {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      return Promise.all(["700 80px Nohemi", "80px nohemimedium"].map((f) => document.fonts.load(f).catch(() => null)));
    }
    function drawSlip(fmt, d) {
      const post = fmt === "post", W = 1080, H = post ? 1350 : 1920;
      const cv = document.createElement("canvas"); cv.width = W; cv.height = H;
      const c = cv.getContext("2d");
      const bg = c.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, SLIP.top); bg.addColorStop(1, SLIP.bottom);
      c.fillStyle = bg; c.fillRect(0, 0, W, H);
      const track = (px) => { if ("letterSpacing" in c) c.letterSpacing = px + "px"; };
      const text = (t, x, y, px, bold, color, align, tr) => {
        c.font = slipFont(px, bold); c.fillStyle = color || SLIP.paper; c.textAlign = align || "left"; c.textBaseline = "alphabetic";
        track(tr || 0); c.fillText(t, x, y); track(0);
      };
      const width = (t, px, bold, tr) => { c.font = slipFont(px, bold); track(tr || 0); const w = c.measureText(t).width; track(0); return w; };
      const fit = (t, px, bold, maxW, min, tr) => { let p = px; while (p > (min || 18) && width(t, p, bold, tr || 0) > maxW) p -= 2; return p; };
      const wrap = (t, px, maxW) => {
        const out = []; let line = "";
        for (const w of t.split(" ")) { const next = line ? line + " " + w : w; if (line && width(next, px, true) > maxW) { out.push(line); line = w; } else line = next; }
        if (line) out.push(line); return out;
      };
      const logo = (x, y, w, color) => { const k = w / 140; c.save(); c.translate(x, y); c.scale(k, k); c.fillStyle = color; for (const p of LOGO_D) c.fill(new Path2D(p)); c.restore(); };
      const chip = (t, x, y, h, bgc, fg) => {
        const px = Math.round(h * 0.44), w = width(t, px, true, 3) + h * 0.8;
        c.fillStyle = bgc; c.fillRect(x, y, w, h); text(t, x + h * 0.4, y + h * 0.66, px, true, fg, "left", 3);
      };
      const face = (x, y, pitch, disc) => {
        const pd = Math.round(pitch * 0.42), w = pitch * 3 + disc + pd * 2, h = pitch * 6 + disc + pd * 2;
        c.fillStyle = SLIP.face; c.fillRect(x, y, w, h);
        for (let r = 0; r < 7; r++) for (let k = 0; k < 4; k++) {
          c.beginPath(); c.arc(x + pd + disc / 2 + k * pitch, y + pd + disc / 2 + r * pitch, disc / 2, 0, Math.PI * 2);
          c.fillStyle = d.s[r] === "Y" ? SLIP.Y : SLIP.R; c.fill();
        }
        /* the NOTICE tab under the face, as on the lamp */
        const tw = Math.round(pitch * 1.5), th = Math.round(pitch * 0.36), lw = tw - th, lh = (lw * 26) / 140;
        c.fillStyle = SLIP.paper; c.fillRect(x, y + h, tw, th);
        logo(x + th / 2, y + h + (th - lh) / 2, lw, SLIP.face);
        return { x, y, w, h, row: (r) => y + pd + disc / 2 + r * pitch, half: disc / 2 };
      };
      const bracket = (F, bx) => {
        if (!d.rows.length) return null;
        const y1 = F.row(Math.min(...d.rows)) - F.half - 12, y2 = F.row(Math.max(...d.rows)) + F.half + 12;
        c.strokeStyle = SLIP.paper; c.lineWidth = 5; c.lineCap = "square";
        c.beginPath(); c.moveTo(bx - 26, y1); c.lineTo(bx, y1); c.lineTo(bx, y2); c.lineTo(bx - 26, y2); c.stroke();
        return (y1 + y2) / 2;
      };
      /* the order's tune, drawn like a climb: each slab's note, low to high */
      const tune = (x, y, w, h) => {
        const lo = Math.log2(196), hi = Math.log2(392 * Math.pow(2, 14 / 12)), pts = [];
        for (let r = 0; r < 7; r++) pts.push([x + (w * r) / 6, y + h - ((Math.log2(note(6 - r, d.s[r])) - lo) / (hi - lo)) * h]);
        c.strokeStyle = SLIP.paper; c.lineWidth = 5; c.lineJoin = "round"; c.lineCap = "round";
        c.beginPath(); pts.forEach(([px, py], i) => (i ? c.lineTo(px, py) : c.moveTo(px, py))); c.stroke();
        pts.forEach(([px, py], i) => { c.beginPath(); c.arc(px, py, 13, 0, Math.PI * 2); c.fillStyle = d.s[i] === "Y" ? SLIP.Y : SLIP.R; c.fill(); c.lineWidth = 4; c.strokeStyle = SLIP.paper; c.stroke(); });
      };
      const label = (lx, cy, maxW, px0) => {
        const t = d.shape.toUpperCase() + ".";
        let px = px0, lines = wrap(t, px, maxW);
        while (px > 34 && (lines.length > 3 || lines.some((l) => width(l, px, true, -1) > maxW))) { px -= 4; lines = wrap(t, px, maxW); }
        const lh = px * 1.02, top = cy - (lines.length * lh) / 2 + px * 0.8;
        lines.forEach((l, i) => text(l, lx, top + i * lh, px, true, SLIP.paper, "left", -1));
      };
      const stat = (name, value, x, y, w) => {
        text(name, x, y, 24, false, SLIP.soft, "left", 4);
        text(value, x, y + 56, fit(value, 46, true, w, 24, 1), true, SLIP.paper, "left", 1);
      };
      const dt = new Date(d.at || Date.now());
      const when = dt.getDate() + " " + dt.toLocaleString("en-GB", { month: "short" }).toUpperCase() + "  " + String(dt.getHours()).padStart(2, "0") + ":" + String(dt.getMinutes()).padStart(2, "0");
      const giftV = d.fun ? "FOR FUN" : d.giftLabel || "—";
      const pullV = d.no ? "#" + String(d.no).padStart(4, "0") : "—";
      const chipT = d.fun ? "FOR FUN" : PRIZES ? "THE PULL THAT COUNTS" : "ONE PULL";
      const chipBg = d.fun ? SLIP.paper : SLIP.Y;
      const n = pad(d.n);
      if (!post) {
        logo(80, 96, 300, SLIP.paper);
        text("STACK 4", W - 80, 128, 40, true, SLIP.paper, "right", 3);
        text("THE PULL", W - 80, 166, 24, false, SLIP.soft, "right", 5);
        chip(chipT, 80, 226, 58, chipBg, SLIP.ink);
        const F = face(80, 320, 110, 88), bx = F.x + F.w + 36, lx = bx + 32;
        const mid = bracket(F, bx);
        if (mid !== null) { c.beginPath(); c.moveTo(bx, mid); c.lineTo(lx - 10, mid); c.stroke(); }
        label(lx, mid !== null ? mid : F.y + F.h / 2, W - 72 - lx, 64);
        text("ORDER", 80, 1272, 26, false, SLIP.soft, "left", 5);
        text(n, 72, 1452, 210, true, SLIP.paper, "left", -6);
        text("/ 35", 80 + width(n, 210, true, -6) + 18, 1452, 72, true, SLIP.soft, "left", 0);
        stat("GIFT", giftV, 80, 1522, W - 160);
        stat("PULL", pullV, 80, 1636, 300); stat("WHEN", when, 420, 1636, W - 500);
        text("THE TUNE", 80, 1772, 24, false, SLIP.soft, "left", 4);
        tune(300, 1730, 700, 58);
        c.fillStyle = "rgba(255,253,248,.28)"; c.fillRect(80, 1820, W - 160, 2);
        text("PULL YOURS: WEARENOTICE.COM", 80, 1872, 28, true, SLIP.paper, "left", 2);
        text("@WEARE.NOTICE", W - 80, 1872, 26, false, SLIP.soft, "right", 2);
      } else {
        logo(80, 82, 250, SLIP.paper);
        text("STACK 4", W - 80, 112, 36, true, SLIP.paper, "right", 3);
        text("THE PULL", W - 80, 146, 22, false, SLIP.soft, "right", 5);
        chip(chipT, 80, 186, 52, chipBg, SLIP.ink);
        const F = face(80, 280, 96, 76);
        bracket(F, F.x + F.w + 30);
        const rx = F.x + F.w + 72, rw = W - 80 - rx;
        label(rx, 400, rw, 64);
        text("ORDER", rx, 590, 24, false, SLIP.soft, "left", 5);
        text(n, rx - 4, 740, 170, true, SLIP.paper, "left", -5);
        text("/ 35", rx + width(n, 170, true, -5) + 12, 740, 58, true, SLIP.soft, "left", 0);
        stat("GIFT", giftV, rx, 820, rw); stat("PULL", pullV, rx, 930, rw); stat("WHEN", when, rx, 1040, rw);
        text("THE TUNE", 80, 1162, 22, false, SLIP.soft, "left", 4);
        tune(260, 1126, 740, 52);
        c.fillStyle = "rgba(255,253,248,.28)"; c.fillRect(80, 1216, W - 160, 2);
        text("PULL YOURS: WEARENOTICE.COM", 80, 1278, 26, true, SLIP.paper, "left", 2);
        text("@WEARE.NOTICE", W - 80, 1278, 24, false, SLIP.soft, "right", 2);
      }
      return cv;
    }
    function slipShareText(d) {
      const what = d.fun ? ", for fun" : d.giftName ? ". First pull: " + d.giftName : "";
      return "Order " + pad(d.n) + " / 35 on the Stack 4 Lamp" + what + ". Your pull: " + location.origin + location.pathname;
    }
    async function renderSlip() {
      if (!lastSlip || !slipImg) return;
      const job = ++slipJob, d = lastSlip, fmt = slipFmt;
      slipDlg.classList.add("is-busy");
      await slipFonts();
      if (job !== slipJob) return;
      const cv = drawSlip(fmt, d);
      const blob = await new Promise((res) => cv.toBlob(res, "image/png"));
      if (job !== slipJob || !blob) return;
      if (slipUrl) URL.revokeObjectURL(slipUrl);
      slipUrl = URL.createObjectURL(blob);
      const name = "stack-4-order-" + pad(d.n) + (d.fun ? "-for-fun" : "") + (fmt === "post" ? "-post" : "") + ".png";
      slipFile = typeof File === "function" ? new File([blob], name, { type: "image/png" }) : null;
      slipImg.width = cv.width; slipImg.height = cv.height; slipImg.src = slipUrl;
      slipSave.href = slipUrl; slipSave.setAttribute("download", name);
      let can = false;
      try { can = !!(slipFile && navigator.canShare && navigator.canShare({ files: [slipFile] })); } catch (e) {}
      slipShare.hidden = !can;
      slipDlg.classList.remove("is-busy");
    }
    if (slipDlg && slipOpen && slipImg) {
      slipOpen.addEventListener("click", () => { if (!lastSlip) return; slipDlg.showModal(); renderSlip(); });
      slipDlg.querySelector(".s4p-slip-close").addEventListener("click", () => slipDlg.close());
      slipDlg.addEventListener("click", (e) => { if (e.target === slipDlg) slipDlg.close(); });
      slipDlg.querySelectorAll(".s4p-slip-tab").forEach((t) => t.addEventListener("click", () => {
        if (slipFmt === t.dataset.fmt) return;
        slipFmt = t.dataset.fmt; slipDlg.dataset.fmt = slipFmt;
        slipDlg.querySelectorAll(".s4p-slip-tab").forEach((x) => x.setAttribute("aria-pressed", String(x === t)));
        renderSlip();
      }));
      /* the file is ready before the tap, so the share sheet opens inside the tap (Safari needs that) */
      slipShare.addEventListener("click", () => {
        if (!slipFile || !navigator.share) return;
        navigator.share({ files: [slipFile], text: slipShareText(lastSlip) }).catch(() => {});
      });
      slipSave.addEventListener("click", (e) => { if (!slipUrl) e.preventDefault(); });
    }

    /* ---------- once a pull is done, the buy card stays on screen (13 Oct) ---------- */
    const buy = q(".s4p-buy");
    function buyLine() {
      const g = PRIZES && saved && saved.gift;
      if (g && g !== "none" && GIFT[g]) return g === "rs444" ? "Rs. 444 off is yours." : "Your " + GIFT[g].label + " ships free with it.";
      return "Played it. Now own it.";
    }
    let chatTimer = 0;
    function liftChat(on) {
      const l = document.getElementById("btn-trigger-chat");
      if (!l) return;
      if (!on || wide.matches || !buy || buy.hidden) {
        if (l.dataset.s4pBottom) { l.style.setProperty("bottom", l.dataset.s4pBottom, "important"); delete l.dataset.s4pBottom; }
        return;
      }
      if (!l.dataset.s4pBottom) l.dataset.s4pBottom = l.style.getPropertyValue("bottom") || getComputedStyle(l).bottom;
      const want = Math.max(parseFloat(l.dataset.s4pBottom) || 20, buy.offsetHeight + 12);
      if (parseFloat(l.style.getPropertyValue("bottom")) !== want) l.style.setProperty("bottom", want + "px", "important");
    }
    function placeBuy() {
      if (!buy || buy.hidden) return;
      buy.style.bottom = "";
      if (!wide.matches) { liftChat(true); return; }
      liftChat(false);
      const cs = getComputedStyle(buy), base = parseFloat(cs.bottom) || 20, left = parseFloat(cs.left) || 0;
      const u = btn.getBoundingClientRect(), h = buy.offsetHeight, w = buy.offsetWidth, top = innerHeight - base - h;
      if (top < u.bottom + 16 && innerHeight - base > u.top - 16 && left < u.right && left + w > u.left) buy.style.bottom = Math.round(innerHeight - u.top + 14) + "px";
    }
    function showBuy() {
      if (!buy) return;
      buy.querySelector(".s4p-buy-gift").textContent = buyLine();
      if (!buy.hidden) { placeBuy(); return; }
      try { if (sessionStorage.getItem("s4p-buy-x")) return; } catch (e) {}
      buy.hidden = false;
      document.documentElement.classList.add("s4p-buy-on");
      placeBuy();
      requestAnimationFrame(() => requestAnimationFrame(() => buy.classList.add("is-on")));
      /* the chat widget loads late and may reset itself, so keep its bubble above the card while it shows */
      clearInterval(chatTimer);
      chatTimer = setInterval(() => { if (buy.hidden) clearInterval(chatTimer); else if (!wide.matches) liftChat(true); }, 1000);
    }
    if (buy) {
      buy.querySelector(".s4p-buy-x").addEventListener("click", () => {
        buy.classList.remove("is-on"); buy.hidden = true; buy.style.bottom = "";
        document.documentElement.classList.remove("s4p-buy-on");
        clearInterval(chatTimer); liftChat(false);
        try { sessionStorage.setItem("s4p-buy-x", "1"); } catch (e) {}
      });
      window.addEventListener("resize", () => requestAnimationFrame(placeBuy));
      window.addEventListener("scroll", () => { if (wide.matches && !buy.hidden) requestAnimationFrame(placeBuy); }, { passive: true });
    }

    /* A returning visitor whose number already pulled: say what is saved before anything moves. */
    if (PRIZES && saved && saved.gift && GIFT[saved.gift] && saved.played === false && ORDERS.includes(saved.order)) {
      pending = { gift: saved.gift, n: saved.n, order: saved.order, until: saved.until, code: saved.code || null, no: saved.no || null, at: saved.pulledAt || null };
      const aim = q(".s4p-note-aim"); if (aim) aim.textContent = "You're in. This pull counts.";
      label.textContent = "Pull for real";
    } else if (PRIZES && saved && saved.gift && GIFT[saved.gift]) {
      label.textContent = "Pull for fun";
      const g = saved.gift, masked = saved.last4 ? "\u2022\u2022\u2022\u2022" + saved.last4 : "your number", until = UNTIL || saved.until || "";
      const head = g === "none" ? "Your number has pulled." : "Your gift is locked in.";
      const text = g === "none" ? "Every pull from here is for fun."
        : g === "rs444" ? (saved.code ? "Code " + saved.code + " takes Rs. 444 off the lamp until " + until + "." : "Rs. 444 off the lamp. Your code comes on WhatsApp.")
        : GIFT[g].label + " ships free with a lamp ordered on " + masked + " by " + until + ".";
      readout("aim", head, text);
      const aim = q(".s4p-note-aim"); if (aim) aim.textContent = head + " " + text;
      showClaim(saved, false);
      showBuy();
    }

    /* ---------- start ---------- */
    setOrder(current);
    setSlider(0);
    renderSound();
    layout();
    markMatrix(current);
    state("rest");
    if (!reduce.matches) {
      setTimeout(() => {
        if (busy || drag || touched || nudging) return;
        tween(460, (k) => { if (!busy && !drag && !nudging) setSlider(22 * Math.sin(Math.PI * k)); });
      }, 1600);
    }
  }

  const boot = (scope) => scope.querySelectorAll("[data-s4p]").forEach(init);
  boot(document);
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();
